import { render, staticRenderFns } from "./ApiIntegradoraConsulta.vue?vue&type=template&id=f3f21d46&scoped=true"
import script from "./ApiIntegradoraConsulta.vue?vue&type=script&lang=js"
export * from "./ApiIntegradoraConsulta.vue?vue&type=script&lang=js"
import style0 from "./ApiIntegradoraConsulta.vue?vue&type=style&index=0&id=f3f21d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f21d46",
  null
  
)

export default component.exports